import { WorkspaceMember } from '@futrli-sdk/people';

import { ApiView, ApiViewState, getDefaultApiViewState } from './core/ApiView';
import { membersQuery } from './queries/members';

export interface MembersViewState extends ApiViewState {
  members: WorkspaceMember[];
}

export class MembersView extends ApiView {
  private membersObs: ReturnType<typeof membersQuery>;

  public state: MembersViewState = {
    ...getDefaultApiViewState(),
    members: []
  };

  constructor(
    private workspaceId: string,
    private organisationId: string,
    private isConsolidation: boolean
  ) {
    super();

    this.membersObs = this.addQuery(membersQuery(workspaceId, organisationId, isConsolidation));

    this.updateState();
  }

  // ****************************
  // *  Private / Protected API *
  // ****************************
  private get members() {
    return this.getResult(this.membersObs).data ?? [];
  }

  protected getNewState(): MembersViewState {
    return {
      ...super.getNewState(),
      members: this.members
    };
  }
}
